import { useEffect, useState } from 'preact/hooks';
import { loadOrders, orders, ordersLoading, ordersError } from '@/store/orders';
import { navigate } from '@/router';
import { numberFormat, formatDate } from '@/utils/format';
import { StatusPill } from '@/ui/StatusPill.jsx';
import { OrderModal } from './OrderModal.jsx';
import { SkeletonList } from '@/ui/Skeleton.jsx';
import { isMobile } from '@/lib/viewport';
import css from './OrdersList.module.css';

export function OrdersList() {
  const [activeOrderId, setActiveOrderId] = useState(null);

  useEffect(() => {
    loadOrders();
  }, []);

  if (ordersLoading.value) {
    return isMobile.value ? (
      <section class="panel">
        <SkeletonList count={5} variant="order" />
      </section>
    ) : (
      <p class="loading">Загрузка заказов</p>
    );
  }
  if (ordersError.value) {
    return <div class="empty-state">Ошибка: {ordersError.value.message}</div>;
  }

  if (orders.value.length === 0) {
    return (
      <div class="panel">
        <div class="empty-state">
          <p>Заказов пока нет</p>
          <button class="btn btn-primary" onClick={() => navigate('search')}>
            Перейти к поиску товаров
          </button>
        </div>
      </div>
    );
  }

  if (isMobile.value) {
    return (
      <>
        <section class="panel">
          <h2 class="panel-title">Ваши заказы</h2>
          <div class={css.cardList}>
            {orders.value.map((order) => {
              const positionsCount = order.positions_count ?? order.items_count ?? '—';
              const totalQty = order.total_quantity ?? '—';
              return (
                <button
                  key={order.id}
                  type="button"
                  class={css.orderCard}
                  onClick={() => setActiveOrderId(order.id)}
                >
                  <div class={css.orderCardTop}>
                    <span class={css.orderNum}>#{order.id}</span>
                    <StatusPill status={order.status} />
                  </div>
                  <div class={css.orderCardSum}>{numberFormat(order.total_price)} ₽</div>
                  <div class={css.orderCardMeta}>
                    <span>{positionsCount} поз. / {totalQty} шт.</span>
                    <span>{formatDate(order.created_at)}</span>
                  </div>
                </button>
              );
            })}
          </div>
        </section>
        {activeOrderId && (
          <OrderModal
            orderId={activeOrderId}
            onClose={() => setActiveOrderId(null)}
            onAfterChange={() => loadOrders()}
          />
        )}
      </>
    );
  }

  return (
    <>
      <section class="panel">
        <h2 class="panel-title">Ваши заказы</h2>
        <div class={css.tableWrap}>
          <table class={css.table}>
            <thead>
              <tr>
                <th>№ заказа</th>
                <th>Статус</th>
                <th>Сумма</th>
                <th>Состав</th>
                <th>Дата</th>
              </tr>
            </thead>
            <tbody>
              {orders.value.map((order) => {
                const positionsCount = order.positions_count ?? order.items_count ?? '—';
                const totalQty = order.total_quantity ?? '—';
                return (
                  <tr
                    key={order.id}
                    class={css.row}
                    onClick={() => setActiveOrderId(order.id)}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') setActiveOrderId(order.id);
                    }}
                  >
                    <td>#{order.id}</td>
                    <td><StatusPill status={order.status} /></td>
                    <td>{numberFormat(order.total_price)} ₽</td>
                    <td>{positionsCount} поз. / {totalQty} шт.</td>
                    <td>{formatDate(order.created_at)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>

      {activeOrderId && (
        <OrderModal
          orderId={activeOrderId}
          onClose={() => setActiveOrderId(null)}
          onAfterChange={() => loadOrders()}
        />
      )}
    </>
  );
}
